var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { ref: "searchBox", staticClass: "search-box" },
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入终端SN" },
                model: {
                  value: _vm.condition.posSn,
                  callback: function ($$v) {
                    _vm.$set(_vm.condition, "posSn", $$v)
                  },
                  expression: "condition.posSn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择终端类型" },
                  model: {
                    value: _vm.condition.amountType,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "amountType", $$v)
                    },
                    expression: "condition.amountType",
                  },
                },
                _vm._l(_vm.amountTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { value: item.code, label: item.desc },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择是否激活" },
                  model: {
                    value: _vm.condition.hasActivate,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "hasActivate", $$v)
                    },
                    expression: "condition.hasActivate",
                  },
                },
                _vm._l(_vm.format.getEnumItems("yesOrNo"), function (item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { value: Number(item.code), label: item.desc },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", placeholder: "请选择分公司" },
                  model: {
                    value: _vm.condition.groupId,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "groupId", $$v)
                    },
                    expression: "condition.groupId",
                  },
                },
                _vm._l(_vm.groupList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { clearable: "", placeholder: "请选择业务员" },
                  model: {
                    value: _vm.condition.salesId,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "salesId", $$v)
                    },
                    expression: "condition.salesId",
                  },
                },
                _vm._l(_vm.salesList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择平台" },
                  model: {
                    value: _vm.condition.platfromType,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "platfromType", $$v)
                    },
                    expression: "condition.platfromType",
                  },
                },
                _vm._l(_vm.platfromTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { value: item.code, label: item.desc },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择审核状态" },
                  model: {
                    value: _vm.condition.auditStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.condition, "auditStatus", $$v)
                    },
                    expression: "condition.auditStatus",
                  },
                },
                _vm._l(_vm.auditStatusOptions, function (item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { value: item.code, label: item.desc },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getPage } },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "erp:terminal:hq:allocate",
                      expression: "'erp:terminal:hq:allocate'",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openDiaog("hq_allocate")
                    },
                  },
                },
                [_vm._v("总部批量分拨")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "erp:terminal:branch:allocate",
                      expression: "'erp:terminal:branch:allocate'",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openDiaog("branch_allocate")
                    },
                  },
                },
                [_vm._v("分公司批量分拨")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "erp:terminal:branch:callback",
                      expression: "'erp:terminal:branch:callback'",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openDiaog("branch_callback")
                    },
                  },
                },
                [_vm._v("批量回拨")]
              ),
              _c("excel-import", {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: "erp:terminal:import",
                    expression: "'erp:terminal:import'",
                  },
                ],
                attrs: {
                  fatherMethod: _vm.getPage,
                  "template-name": "ErpTerminalInventoryImport.xlsx",
                  url: "/erp/terminal/inventory/excelImport",
                  template: "ErpTerminalInventoryImport.xlsx",
                  "class-name": "ErpTerminalInventoryImport",
                  title: "导入",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "listTable",
          attrs: { data: _vm.tableData, height: _vm.tableHeight, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "posSn",
              align: "center",
              "min-width": "160",
              label: "终端号",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row.id, true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.posSn))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platfromName",
              align: "center",
              "min-width": "160",
              label: "平台名称",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "groupName",
              align: "center",
              "min-width": "160",
              label: "分公司",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "salesName",
              align: "center",
              "min-width": "160",
              label: "业务员",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "amountType",
              align: "center",
              "min-width": "160",
              label: "终端类型",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "hasActivate",
              align: "center",
              "min-width": "160",
              label: "是否激活",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formatBoolean(scope.row.hasActivate)) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "activateTime",
              align: "center",
              "min-width": "160",
              label: "激活时间",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "auditStatus",
              align: "center",
              width: "120",
              label: "审核状态",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatAuditStatus")(
                            scope.row.auditStatus,
                            _vm.that
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "erp:terminal:update",
                            expression: "'erp:terminal:update'",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row.id, false)
                          },
                        },
                      },
                      [_vm._v("修改")]
                    ),
                    scope.row.hasActivate === 0 && scope.row.currentStage === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "erp:terminal:hq:allocate",
                                expression: "'erp:terminal:hq:allocate'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandler(scope.row, "hq_allocate")
                              },
                            },
                          },
                          [_vm._v("总部下拨")]
                        )
                      : _vm._e(),
                    scope.row.hasActivate === 0 && scope.row.currentStage === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "erp:terminal:branch:allocate",
                                expression: "'erp:terminal:branch:allocate'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandler(
                                  scope.row,
                                  "branch_allocate"
                                )
                              },
                            },
                          },
                          [_vm._v("分部下拨")]
                        )
                      : _vm._e(),
                    scope.row.hasActivate === 0 &&
                    (scope.row.currentStage === 1 ||
                      scope.row.currentStage === 2) &&
                    scope.row.auditStatus !== 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "erp:terminal:branch:callback",
                                expression: "'erp:terminal:branch:callback'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandler(
                                  scope.row,
                                  "branch_callback"
                                )
                              },
                            },
                          },
                          [_vm._v("回拨")]
                        )
                      : _vm._e(),
                    scope.row.currentStage === 1 && scope.row.auditStatus === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "erp:terminal:branch:audit",
                                expression: "'erp:terminal:branch:audit'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAudit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex-center-end",
          staticStyle: { "margin-top": "10px" },
        },
        [
          _c("pagination", {
            attrs: {
              total: _vm.pagination.total,
              page: _vm.pagination.current,
              limit: _vm.pagination.size,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.pagination, "size", $event)
              },
              pagination: _vm.getPage,
            },
          }),
        ],
        1
      ),
      _c("AllocateDialog", {
        ref: "allocateDialogRef",
        on: { success: _vm.getPage },
      }),
      _c("TerminalEditDialog", {
        ref: "terminalEditDialogRef",
        on: { success: _vm.getPage },
      }),
      _c("TerminalAuditDialog", {
        ref: "terminalAuditDialogRef",
        on: { success: _vm.getPage },
      }),
      _c("TerminalSingleOperationDialog", {
        ref: "terminalSingleOperationDialogRef",
        on: { success: _vm.getPage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }